import type { IRouteItem } from "@/app/ui/navigation/types";
import versionManager from "@/store/modules/versionManager";
import type { RouteConfig } from "vue-router/types/router";
import { getTpRouteItems, tpRoutes } from "@tp/routes";
import router, {
  addCommonBmTpRouterAfterEach,
  pageCounter,
  useCommonBmTpRouterBackWithFallback,
} from "@/router/router";
import { ensureSessionEstablishedForStore } from "@tp/tpSession";

export const configureRouterForTp = () => {
  const routes: RouteConfig[] = [
    { path: "/", redirect: "/home" },
    // Fall-through 404
    //{ path: "*", name: "not-found", component: NotFound },
  ];

  // The routes for the menu items are added via the UI component.
  const routeAdder = (ri: IRouteItem): void => {
    // TODO - make url mandatory for routes once they are properly split from menus.
    if (ri.url) {
      routes.push({
        name: ri.childRoutes.some((r) => r.path === "") ? undefined : ri.name, // dont set a name if any of our child routes have a default path
        path: ri.url ? "/tradeportal" + ri.url : ri.url, // all tradeportal routes are beneath /tradeportal
        component: ri.view,
        meta: {
          ...ri.routeMetadata,
          requiredUserPermissions: ri.requiredUserPermissions,
        },
        children: ri.childRoutes,
        props: ri.componentProps,
        redirect: ri.redirect,
      });
    }

    if (ri.subMenus) {
      ri.subMenus.forEach(routeAdder);
    }
  };

  getTpRouteItems().forEach(routeAdder);

  for (const route of routes) {
    router.addRoute(route);
  }

  // This guard will ensure the router forwards to the signin page if the user is not logged in.
  router.beforeEach(async (to, from, next): Promise<any> => {
    // Check to see if our view of the server version is consistent with the latest API calls
    // if not perform a full refresh.
    if (versionManager.requiresRefresh()) {
      location.href = to.fullPath;
    }

    const storeId = (to.params.storeid ?? "").toLocaleLowerCase();
    // Not authenticated, ask to sign in
    if (
      !to.meta?.preSession &&
      !(await ensureSessionEstablishedForStore(to.params.storeid))
    ) {
      next(tpRoutes.signIn.location(storeId));
    }

    pageCounter.value++;
    next();
  });

  addCommonBmTpRouterAfterEach();
  useCommonBmTpRouterBackWithFallback();
};
